'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Relay42Service.$inject = ['Relay42Constants', '$q', '$window', '$interval'];


var _module = _angular2.default.module('cb.core.relay42.Relay42Service', []);

_module.service('Relay42Service', Relay42Service);

exports.default = _module;


function Relay42Service(Relay42Constants, $q, $window, $interval) {
    var service = {
        getCookiePermissionLevel: getCookiePermissionLevel,
        showCookieSettings: showCookieSettings
    };

    return service;

    /* Get customer's cookie permission level from the Relay42 global object,
     * where 1 means "Zeer beperkt (functioneel)", 2 means "Beperkt
     * (functioneel & statistiek)" and 3 means "Standaard (functioneel,
     * statistiek & extern)".
     *
     * Returns a promise, because even after `_st` is available, it takes some
     * time before `_st.cookiepermission` contains a value.  Will return in at
     * most 2 seconds.  If not available in time, will return the default
     * level.
     */
    function getCookiePermissionLevel() {
        var result = $q.defer();

        var permission = Relay42Constants.DEFAULT_COOKIE_PERMISSION_LEVEL;
        var count = 0;

        var timer = $interval(function () {
            if (typeof $window._st !== 'undefined' && typeof $window._st.cookiepermission !== 'undefined') {
                var permissions = $window._st.cookiepermission.getCookiePreferences();

                if (permissions[1] === true) {
                    permission = 1;
                }
                if (permissions[2] === true) {
                    permission = 2;
                }
                if (permissions[3] === true) {
                    permission = 3;
                }

                $interval.cancel(timer);
                result.resolve(permission);
            }

            if (count >= 2000) {
                $interval.cancel(timer);
                result.resolve(permission);
            }

            count += 100;
        }, 100);

        return result.promise;
    }

    function showCookieSettings() {
        if (typeof $window._stCookiePopup !== 'undefined') {
            $window._stCookiePopup.showSettings();
        }
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/core/relay42/relay42.service.js
// module id = 814
// module chunks = 0